export const TimeFilter = {
    Live: 'Live',
    Upcoming: 'Upcoming',
    Today: 'Today',
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    All: 'All',
} as const;
export type TimeFilter = typeof TimeFilter[keyof typeof TimeFilter];

export interface TimeSpan {
    startDate: Date;
    endDate: Date;
}
